import React, { useLayoutEffect, useRef } from 'react';

export interface QueryDescriptionProps {
  value: string | undefined;
  editable: boolean;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

export function QueryDescription({
  value,
  editable,
  onChange,
}: QueryDescriptionProps) {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  // Auto-expand textarea to fit content
  useLayoutEffect(() => {
    if (textareaRef.current && editable && value) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [value, editable]);

  if (editable) {
    return (
      <textarea
        ref={textareaRef}
        value={value || ''}
        onChange={onChange}
        className="text-chariot-text-secondary mt-2 w-full resize-none overflow-hidden bg-transparent text-sm outline-none"
        placeholder="Add a description..."
        data-testid="query-header-description-input"
        rows={1}
        onInput={e => {
          const target = e.target as HTMLTextAreaElement;
          target.style.height = 'auto';
          target.style.height = `${target.scrollHeight}px`;
        }}
      />
    );
  }

  // In VIEW mode, description is shown as tooltip on InfoIcon, not inline
  return null;
}
